import React, { useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";

//API
import ItemServiceV2 from "../../../../../services/inventory_appCommonService";
//Components
import { InputField } from "../../../../../Components/formElements/InputField";
import FailureModal from "../../../../../Components/Modal/supplier_app/FailureModal";
import toast from "react-hot-toast";

import Layout from "../../../../../Layout/Layout";
import { isValidNumber, } from "../../../../../common/Validations";
import { useDispatch } from "react-redux";
import { getProductionOrderList } from "../../../../../redux/feature/inventory_app/inventorySlice";
import InventoryConstants from "../../../../../common/InventoryConstants";

const message = {
  VALID_CUSTOMER_NAME: "Special characters or numbers are not allowed.",
  VALID_ALTERNATE_MAIL_ID: "Please enter a valid alternate email address.",
  VALID_CONTACT_NUMBER: "Please enter a valid contact number.",
  VALID_ALTERNATE_CONTACT_NUMBER:
    "Please enter a valid alternate contact number.",
  VALID_PURPOSE_JUSTIFICATION:
    "Please ensure the justification is under 500 characters.",
  VALID_POSTAL_CODE:
    "Enter a 6-character postal code with uppercase letters and numbers only",
  VALID_CONTACT_FIRST_NAME: "Special characters and numbers are not allowed",
  VALID_CONTACT_LAST_NAME: "Special characters and numbers are not allowed",
  EXIStS_MAIL_ID: "Email already exists",
  EXIStS_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_CONTACT_NUMBER: "Contact Number already exists",
  EXIStS_ALTERNATE_MAIL_ID: "Alternate Contact Number already exists",
  FILL_REQUIRED_FIELD: "Please fill the required field",
  ALTERNATE_MAIL_ID: "Email ID is same",
  ALTERNATE_CONTACT_NUMBER: "Contact number is same",
  GET_MAP_DISTANCE: "Please Click the Get Distance & Time button",
  NUMBER_ALLOWED: "Please enter a valid number."
};

const CreateOrder = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  /* pop failure modal */
  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };
  const [isCardVisible, setCardVisible] = useState(true);
  const [getFailureModal] = useState(failureModalData);
  const [getShowFailureModal, setShowFailureModal] = useState(false);
  const [getErrorFields, /*setErrorFields*/] = useState([]);

  const [validation, setValidation] = useState({
    Quantity: "",
    // confirmedQty: "",

  });
  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const onInputChange = ({ target: { name, value } }) => {

    let error = "";

    if (name === "Quantity" && !isValidNumber(value)) {
      error = message.NUMBER_ALLOWED;
    }
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
    setValidation((prev) => ({
      ...prev,
      [name]: error,
    }));
  };
  const [formInputs, setFormInputs] = useState({
    warehouseNr: "",
    warehouseStatus: "",
    orderDate: "",
    activityArea: "",
    woCreatnRule: "",
    resource: "",
    queue: "",
    wave: "",
    createdBy: "",
    processor: "",
    confirmedBy: "",

    warehouseTask: "",
    wtStatus: "",
    product: "",
    batchNr: "",
    serialNoReqm: "",
    sourceBin: "",
    destinationBin: "",
    srceTgtQty: "",
    actDestQty: "",
    actualQtyVum: "",
    destDiffQty: "",
    diffQtyVum: "",
    remQtySource: "",
    exceptionCode: "",
    ptwyPiPlan: "",
    ptwyPiDone: "",
    lowStockQty: "",
    procCategory: "",
    sourceHu: "",
    destinationHu: "",
    actualPos: "",
    destResource: "",
    destinationTu: "",
    grDate: "",
    expiration: "",
    slsOrderProj: "",
    docCatDeter: "",
    owner: "",
    disposalParty: ""
  });

  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "GET_PRODUCTOIN_ORDER_LIST",
      module: "PRODUCTOIN_ORDER",
      page: 1,
      per_page: 10,
      searchTerm: "",
    };
    dispatch(getProductionOrderList(obj));
  };

  const [disabled, setDisabled] = useState(false);

  // SAVE
  const handleSave = async () => {
    // const requiredFields = [];
    // // let hasError = false;
    // const validationErrors = {};

    // if (!validateRequired(formInputs.Quantity)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     Quantity: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // if (!isValidNumber(formInputs.Quantity)) {
    //   requiredFields.push(`${message.FILL_REQUIRED_FIELD}`);
    //   setErrorFields(requiredFields);
    //   setShowFailureModal(true);
    //   setValidation((prev) => ({
    //     ...prev,
    //     Quantity: message.FILL_REQUIRED_FIELD,
    //   }));
    //   return;
    // }
    // setValidation((prev) => ({
    //   ...prev,
    //   ...validationErrors,
    // }));


    const obj = {
      data: formInputs,
    };
    console.log("Data",obj);
    
    setDisabled(true);

    await ItemServiceV2.addProductionOrder(obj).then((item) => {
      if (item?.status === 200) {
        handleSearchFuncApi();
        toast.success(item?.message || "added successfully", {
          duration: 2000,
          position: "top-right",
        });
        dispatch(getProductionOrderList({}))
        navigate(InventoryConstants.INVENTORY_ORDER_LIST)
        // props.onHide();
      } else {
        // setErrorMsg('*'+ item?.message);
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
      setDisabled(false);
    });
  };
  const hideFailureModal = () => {
    setShowFailureModal(false);
  };

  //bank end
  return (
    <main className="dashboard main sri-venkateshwara" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Create Order</h2>
            <p className="subText">
              {/* Register as a new Vehicle or Sub-Contractor with our Company */}
            </p>
            <hr />
            {/* customer details */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">WO</span>
                    </Col>
                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">Warehouse Order </span>
                      <span className="subHeaderTitle">WareHouse Order Entry</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${isCardVisible ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Warehouse Nr"
                          name="warehousrNr"
                          placeholder=""
                          value={formInputs?.warehousrNr || ""}
                          onChange={onInputChange}
                          error={validation.warehousrNr}
                        // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Warehouse Status"
                          name="warehouseStatus"
                          placeholder=""
                          value={formInputs?.warehouseStatus || ""}
                          onChange={onInputChange}
                          error={validation?.warehouseStatus}
                        // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          type="date"
                          label="Date"
                          name="orderDate"
                          id="orderDate"
                          value={formInputs?.orderDate}
                          onChange={onInputChange}
                        // disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Activity Area"
                          name="activityArea"
                          placeholder=""
                          value={formInputs?.activityArea || ""}
                          onChange={onInputChange}
                          error={validation.activityArea}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="WO Creatn Rule"
                          name="woCreatnRule"
                          placeholder=""
                          value={formInputs?.woCreatnRule || ""}
                          onChange={onInputChange}
                          error={validation.woCreatnRule}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Resource"
                          name="resource"
                          placeholder=""
                          value={formInputs?.resource || ""}
                          onChange={onInputChange}
                          error={validation.resource}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Queue"
                          name="queue"
                          placeholder=""
                          value={formInputs?.queue || ""}
                          onChange={onInputChange}
                          error={validation.queue}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Wave"
                          name="wave"
                          placeholder=""
                          value={formInputs?.wave || ""}
                          onChange={onInputChange}
                          error={validation.wave}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Created By"
                          name="createdBy"
                          placeholder=""
                          value={formInputs?.createdBy || ""}
                          onChange={onInputChange}
                          error={validation.createdBy}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Processor"
                          name="processor"
                          placeholder=""
                          value={formInputs?.processor || ""}
                          onChange={onInputChange}
                          error={validation.processor}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Confirmed By"
                          name="confirmedBy"
                          placeholder=""
                          value={formInputs?.confirmedBy || ""}
                          onChange={onInputChange}
                          error={validation.confirmedBy}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* customer Doucment Type */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">PW</span>
                    </Col>
                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">Product WT </span>
                      <span className="subHeaderTitle">Product Warehouse Task</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${isCardVisible ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Warehouse Task"
                          name="warehouseTask"
                          placeholder=""
                          value={formInputs.warehouseTask || ""}
                          onChange={onInputChange}
                          required={true}
                          error={validation.warehouseTask}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Wt Status"
                          name="wtStatus"
                          placeholder=""
                          value={formInputs?.wtStatus || ""}
                          onChange={onInputChange}
                          error={validation.wtStatus}
                        // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Product"
                          name="product"
                          placeholder=""
                          value={formInputs?.product || ""}
                          onChange={onInputChange}
                          error={validation.product}
                        // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Batch"
                          name="batchNr"
                          placeholder=""
                          value={formInputs?.batchNr || ""}
                          onChange={onInputChange}
                          error={validation.batchNr}
                        // required={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Serial No. Reqm"
                          name="serialNoReqm"
                          placeholder=""
                          value={formInputs?.serialNoReqm || ""}
                          onChange={onInputChange}
                          error={validation.serialNoReqm}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Source Bin"
                          name="sourceBin"
                          placeholder=""
                          value={formInputs?.sourceBin || ""}
                          onChange={onInputChange}
                          error={validation.sourceBin}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Destination Bin"
                          name="destinationBin"
                          placeholder=""
                          value={formInputs?.destinationBin || ""}
                          onChange={onInputChange}
                          error={validation.destinationBin}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Srce Tgt Qty"
                          name="srceTgtQty"
                          placeholder=""
                          value={formInputs?.srceTgtQty || ""}
                          onChange={onInputChange}
                          error={validation.srceTgtQty}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Act. Dest. Qty"
                          name="actDestQty"
                          placeholder=""
                          value={formInputs?.actDestQty || ""}
                          onChange={onInputChange}
                          error={validation.actDestQty}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Actual Qty VUM"
                          name="actualQtyVum"
                          placeholder=""
                          value={formInputs?.actualQtyVum || ""}
                          onChange={onInputChange}
                          error={validation.actualQtyVum}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Dest. Diff. Qty"
                          name="destDiffQty"
                          placeholder=""
                          value={formInputs?.destDiffQty || ""}
                          onChange={onInputChange}
                          error={validation.destDiffQty}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Diff. Qty VUM"
                          name="diffQtyVum"
                          placeholder=""
                          value={formInputs?.diffQtyVum || ""}
                          onChange={onInputChange}
                          error={validation.diffQtyVum}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Rem. Qty Source"
                          name="remQtySource"
                          placeholder=""
                          value={formInputs?.remQtySource || ""}
                          onChange={onInputChange}
                          error={validation.remQtySource}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Exception Code"
                          name="exceptionCode"
                          placeholder=""
                          value={formInputs?.exceptionCode || ""}
                          onChange={onInputChange}
                          error={validation.exceptionCode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Ptwy PI Plan"
                          name="ptwyPiPlan"
                          placeholder=""
                          value={formInputs?.ptwyPiPlan || ""}
                          onChange={onInputChange}
                          error={validation.ptwyPiPlan}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Ptwy PI Done"
                          name="ptwyPiDone"
                          placeholder=""
                          value={formInputs?.ptwyPiDone || ""}
                          onChange={onInputChange}
                          error={validation.ptwyPiDone}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Low Stock Qty"
                          name="lowStockQty"
                          placeholder=""
                          value={formInputs?.lowStockQty || ""}
                          onChange={onInputChange}
                          error={validation.lowStockQty}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Low Stock Qty"
                          name="procCategory"
                          placeholder=""
                          value={formInputs?.procCategory || ""}
                          onChange={onInputChange}
                          error={validation.procCategory}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Source Hu"
                          name="sourceHu"
                          placeholder=""
                          value={formInputs?.sourceHu || ""}
                          onChange={onInputChange}
                          error={validation.sourceHu}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Destination Hu"
                          name="destinationHu"
                          placeholder=""
                          value={formInputs?.destinationHu || ""}
                          onChange={onInputChange}
                          error={validation.destinationHu}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Actual Pos"
                          name="actualPos"
                          placeholder=""
                          value={formInputs?.actualPos || ""}
                          onChange={onInputChange}
                          error={validation.actualPos}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Dest Resource"
                          name="destResource"
                          placeholder=""
                          value={formInputs?.destResource || ""}
                          onChange={onInputChange}
                          error={validation.destResource}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Destination Tu"
                          name="destinationTu"
                          placeholder=""
                          value={formInputs?.destinationTu || ""}
                          onChange={onInputChange}
                          error={validation.destinationTu}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          type="date"
                          label="GR Date"
                          name="grDate"
                          id="grDate"
                          value={formInputs?.grDate}
                          onChange={onInputChange}
                        // disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Expiration"
                          name="expiration"
                          placeholder=""
                          value={formInputs?.expiration || ""}
                          onChange={onInputChange}
                          error={validation.expiration}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Sls Order/Proj"
                          name="slsOrderProj"
                          placeholder=""
                          value={formInputs?.slsOrderProj || ""}
                          onChange={onInputChange}
                          error={validation.slsOrderProj}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Doc Cat, Deter"
                          name="docCatDeter"
                          placeholder=""
                          value={formInputs?.docCatDeter || ""}
                          onChange={onInputChange}
                          error={validation.docCatDeter}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Owner"
                          name="owner"
                          placeholder=""
                          value={formInputs?.owner || ""}
                          onChange={onInputChange}
                          error={validation.owner}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={6}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Disposal Party"
                          name="disposalParty"
                          placeholder=""
                          value={formInputs?.disposalParty || ""}
                          onChange={onInputChange}
                          error={validation.disposalParty}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <Row className="mb-4">
        <Col
          xs={12}
          md={{ span: 2, offset: 10 }}
          lg={{ span: 2, offset: 10 }}
          className="text-left"
        >
          <button className="btnTable" onClick={handleSave} disabled={disabled}>
            <i className="bi bi-save"></i> Create
          </button>
        </Col>
      </Row>

      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />
    </main>
  );
};

export default CreateOrder;
